import React from 'react';
import Navbar from './components/navbar';

function App() {
  return (
    <div >
   <Navbar/>
    </div>
  );
}

export default App;
